var React = require('react');

function Fribourg (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"fill":"#FFF","d":"M.203 235.97h466.899v233.432H.203z","key":0}),React.createElement("path",{"fill":"#010202","d":"M.203.951h466.899v234.224H.203z","key":1})]));
}

Fribourg.defaultProps = {"viewBox":"0 0 468 470"};

module.exports = Fribourg;

Fribourg.default = Fribourg;
